import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './LandingPage.module.css';

import Landing2 from '../../img/landing2.png';

const LandingPage = () => {
    const navigate = useNavigate();
    return (
        <>
            <div className={styles['landing-page-container']}>
                {/* <div className={styles["landing-page-box"]}>
          <h2>Landing Page One</h2>
          <div className={styles["landing-page-buttons"]}>
            <button
              onClick={() => navigate("/landing1/1")}
              className={styles["landing-page-preview-button"]}
            >
              Preview
            </button>
            <button
              className={styles["landing-page-select-button"]}
              onClick={() => navigate("/landing1/edit/" + 1)}
            >
              Select
            </button>
          </div>
          <div className={styles["landing-page-image"]}>
            <img src={Landing1} alt="Preview 1" />
          </div>
        </div> */}

                <div className={styles['landing-page-box']}>
                    <div className={styles['landing-page-buttons']}>
                        {/* <button
              onClick={() => navigate("/landing/1")}
              className={styles["landing-page-preview-button"]}
            >
              Preview
            </button> */}
                        <button
                            className={styles['landing-page-select-button']}
                            onClick={() => navigate('/landing/edit/1')}
                        >
                            Create Landing Page
                        </button>
                    </div>
                    <div className={styles['landing-page-image']}>
                        <img src={Landing2} alt="Preview 2" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default LandingPage;
